import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFlightAuditReport } from '_services/flight-audit-report-service';

export const fetchFlightAuditReport = createAsyncThunk(
  'flightAuditReport/fetch',
  async (params) => {
    const { geolocations, beaconEvents } = await getFlightAuditReport(params);
    return { geolocations, beaconEvents };
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,

  beaconData: null,
  beaconStatus: 'idle',
  beaconError: null,
};

const flightAuditReportSlice = createSlice({
  name: 'flightAuditReport',
  initialState,
  reducers: {
    resetFlightAuditReport: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
      state.beaconData = null;
      state.beaconStatus = 'idle';
      state.beaconError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFlightAuditReport.pending, (state) => {
        state.status = 'loading';
        state.beaconStatus = 'loading';
        state.error = null;
        state.beaconError = null;
      })
      .addCase(fetchFlightAuditReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.beaconStatus = 'succeeded';
        state.data = action.payload.geolocations;
        state.beaconData = action.payload.beaconEvents;
        state.error = null;
        state.beaconError = null;
      })
      .addCase(fetchFlightAuditReport.rejected, (state, action) => {
        state.status = 'failed';
        state.beaconStatus = 'failed';
        state.error = action.error.message;
        state.beaconError = action.error.message;
      });
  },
});

// Geolocation selectors
export const selectFlightAuditReportData = (state) => state.flightAuditReport.data;
export const selectFlightAuditReportCoordinates = (state) => {
  const data = state.flightAuditReport.data;
  if (!data) return null;
  return data.map((doc) => ({
    latitude: doc.latitude,
    longitude: doc.longitude,
    timestamp: doc.timestamp,
  }));
};
export const selectFlightAuditReportStatus = (state) => state.flightAuditReport.status;
export const selectFlightAuditReportError = (state) => state.flightAuditReport.error;

// Beacon selectors
export const selectFlightAuditBeaconData = (state) => state.flightAuditReport.beaconData;
export const selectFlightAuditBeaconCoordinates = (state) => {
  const data = state.flightAuditReport.beaconData;
  if (!data) return null;
  return data.map((doc) => ({
    id: doc.id,
    major: doc.major,
    minor: doc.minor,
    timestamp: new Date(doc.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
  }));
};
export const selectFlightAuditBeaconStatus = (state) => state.flightAuditReport.beaconStatus;
export const selectFlightAuditBeaconError = (state) => state.flightAuditReport.beaconError;

export const { resetFlightAuditReport } = flightAuditReportSlice.actions;

export default flightAuditReportSlice.reducer;
